var delayBanner = $('.newBannerSwiper').attr('data-delay');
var playState = $('.newBannerSwiper').attr('data-autoplay');
var heightState = $('.newBannerSwiper').attr('data-autoHeight')
if(heightState){

    if(playState=='true'){
        var swiperNewbanner = new Swiper(".newBannerSwiper .mySwiper", {
            effect:'fade',
            autoHeight:true,
            navigation: {
                nextEl: ".newBannerSwiper .swiper-button-next",
                prevEl: ".newBannerSwiper .swiper-button-prev",
            },
            loop:true,
            autoplay:{
                delay:delayBanner*1000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".newBannerSwiper .swiper-pagination",
                clickable: true,
            }
        });
    }else{
        var swiperNewbanner = new Swiper(".newBannerSwiper .mySwiper", {
            effect:'fade',
            autoHeight:true,
            navigation: {
                nextEl: ".newBannerSwiper .swiper-button-next",
                prevEl: ".newBannerSwiper .swiper-button-prev",
            },
            autoplay:false,
            loop:true,
            pagination: {
                el: ".newBannerSwiper .swiper-pagination",
                clickable: true,
            }
        });
        console.log(2);
    }
}else{
    if(playState=='true'){
        var swiperNewbanner = new Swiper(".newBannerSwiper .mySwiper", {
            effect:'fade',
            
            navigation: {
                nextEl: ".newBannerSwiper .swiper-button-next",
                prevEl: ".newBannerSwiper .swiper-button-prev",
            },
            loop:true,
            autoplay:{
                delay:delayBanner*1000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".newBannerSwiper .swiper-pagination",
                clickable: true,
            }
        });
    }else{
        var swiperNewbanner = new Swiper(".newBannerSwiper .mySwiper", {
            effect:'fade',
            
            navigation: {
                nextEl: ".newBannerSwiper .swiper-button-next",
                prevEl: ".newBannerSwiper .swiper-button-prev",
            },
            loop:true,
            autoplay:false,
            pagination: {
                el: ".newBannerSwiper .swiper-pagination",
                clickable: true,
            }
        });
        console.log(2);
    }
}

